import Vue from 'vue';
import { getCampaigns } from 'widget/api/campaign';
import campaignTimer from 'widget/helpers/campaignTimer';
import {
  formatCampaigns,
  filterCampaigns,
} from 'widget/helpers/campaignHelper';
const state = {
  records: [],
  uiFlags: {
    isError: false,
    hasFetched: false,
  },
  activeCampaign: {},
  isCampaignMessageClicked: false,
  campaignTrigger: {},
};
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const resetCampaignTimers = (campaigns, currentURL, isInBusinessHours) => {
  const formattedCampaigns = formatCampaigns({ campaigns });
  // Find all campaigns that matches the current URL
  const filteredCampaigns = filterCampaigns({
    campaigns: formattedCampaigns,
    currentURL,
    isInBusinessHours,
  });
  campaignTimer.initTimers({ campaigns: filteredCampaigns });
};

export const getters = {
  getHasFetched: $state => $state.uiFlags.hasFetched,
  getCampaigns: $state => $state.records,
  getActiveCampaign: $state => $state.activeCampaign,
  getIsCampaignMessageClicked: $state => $state.isCampaignMessageClicked,
  getCampaignTrigger: $state => $state.campaignTrigger,
};

export const actions = {
  fetchCampaigns: async ({ commit }, { websiteToken, currentURL, isInBusinessHours }) => {
    try {
      const { data: campaigns } = await getCampaigns(websiteToken);
      commit('setCampaigns', campaigns);
      commit('setError', false);
      commit('setHasFetched', true);
      resetCampaignTimers(campaigns, currentURL, isInBusinessHours);
    } catch (error) {
      commit('setError', true);
      commit('setHasFetched', true);
      sendExceptionToSentry(error);
    }
  },
  initCampaigns: async (
    { getters: { getCampaigns: campaigns }, dispatch },
    { currentURL, websiteToken, isInBusinessHours }
  ) => {
    if (!campaigns.length) {
      dispatch('fetchCampaigns', { websiteToken, currentURL, isInBusinessHours });
    } else {
      resetCampaignTimers(campaigns, currentURL, isInBusinessHours);
    }
  },
  startCampaign: async (
    { getters: { getCampaigns: campaigns }, commit },
    { campaignId }
  ) => {
    const campaign = campaigns.find(item => item.id === campaignId);
    commit('setActiveCampaign', campaign);
  },

  executeCampaign: async ({ commit }) => {
    try {
      commit('setActiveCampaign', {});
    } catch (error) {
      commit('setError', true);
      sendExceptionToSentry(error);
    }
  },

  campaignMessageClicked: (
    { commit },
    value 
  ) => {
    commit('setIsCampaignMessageClicked', value);
  },

  setCampaignTrigger: (
    { commit },
    value 
  ) => {
    commit('setCampaignTrigger', value);
  },
};

export const mutations = {
  setCampaigns($state, data) {
    Vue.set($state, 'records', data);
  },
  setActiveCampaign($state, data) {
    Vue.set($state, 'activeCampaign', data);
  },
  setError($state, value) {
    Vue.set($state.uiFlags, 'isError', value);
  },
  setHasFetched($state, value) {
    Vue.set($state.uiFlags, 'hasFetched', value);
  },
  setIsCampaignMessageClicked($state, data) {
    Vue.set($state, 'isCampaignMessageClicked', data);
  },
  setCampaignTrigger($state, data) {
    Vue.set($state, 'campaignTrigger', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
